import { render, staticRenderFns } from "./ReportTabInsights.vue?vue&type=template&id=0ee2575c&scoped=true"
import script from "./ReportTabInsights.vue?vue&type=script&lang=js"
export * from "./ReportTabInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee2575c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee2575c')) {
      api.createRecord('0ee2575c', component.options)
    } else {
      api.reload('0ee2575c', component.options)
    }
    module.hot.accept("./ReportTabInsights.vue?vue&type=template&id=0ee2575c&scoped=true", function () {
      api.rerender('0ee2575c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Report/Tab/ReportTabInsights.vue"
export default component.exports